import { startOfWeekLocale } from 'components/DateRangePicker/mondayBasedLocales';
import addDays from 'date-fns/addDays';
import React from 'react';
import formatDate from 'utils/formatDate';

const CSS = require('./WeekHeader.module.scss');

const TODAY = new Date();
const START_OF_WEEKDAY = startOfWeekLocale(TODAY);

function WeekHeader() {
  return (
    <ol className={CSS.WeekHeader}>
      <li className={CSS.WeekDay}>{formatDate(START_OF_WEEKDAY, 'EEEEEE	')}</li>
      <li className={CSS.WeekDay}>
        {formatDate(addDays(START_OF_WEEKDAY, 1), 'EEEEEE')}
      </li>
      <li className={CSS.WeekDay}>
        {formatDate(addDays(START_OF_WEEKDAY, 2), 'EEEEEE')}
      </li>
      <li className={CSS.WeekDay}>
        {formatDate(addDays(START_OF_WEEKDAY, 3), 'EEEEEE')}
      </li>
      <li className={CSS.WeekDay}>
        {formatDate(addDays(START_OF_WEEKDAY, 4), 'EEEEEE')}
      </li>
      <li className={CSS.WeekDay}>
        {formatDate(addDays(START_OF_WEEKDAY, 5), 'EEEEEE')}
      </li>
      <li className={CSS.WeekDay}>
        {formatDate(addDays(START_OF_WEEKDAY, 6), 'EEEEEE')}
      </li>
    </ol>
  );
}

export default WeekHeader;
